import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IStaticStylesConfig } from '../../../skins/_primitives/IStaticStylesConfig';
import { MatwinsSkins } from '../../../skins/global.skin';

export enum AlertModalResult {
  Yes = 'yes',
  No = 'no',
  Close = 'close'
}

@Component({
  selector: 'app-alert-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-dialog.component.html'
})
export class AlertModalComponent {

  @Input() Skin: IStaticStylesConfig = MatwinsSkins.V1;
  @Input() title!: string;
  @Input() message!: string;
  @Input() messageClasses: string = '';
  @Input() yesButtonText: string = 'Yes';
  @Input() noButtonText: string = 'No';

  @Output() result = new EventEmitter<AlertModalResult>();

  onYes(): void {
    this.result.emit(AlertModalResult.Yes);
  }

  onNo(): void {
    this.result.emit(AlertModalResult.No);
  }

  onClose(): void {
    this.result.emit(AlertModalResult.Close);
  }

  onBackdropClick(event: MouseEvent): void {
    // Fermer le modal si on clique sur le fond
    this.onClose();
  }
}
